import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import PipeDataIntoWarehousePng2x from './assets/PipeDataIntoWarehouse@2x.png'
import PipeDataIntoWarehouseWebp from './assets/PipeDataIntoWarehouse.webp'
import PipeDataIntoWarehouseWebp2x from './assets/PipeDataIntoWarehouse@2x.webp'
import PipeDataIntoWarehouseWebp3x from './assets/PipeDataIntoWarehouse@3x.webp'

const copy = {
  heading: `Pipe data into your warehouse`,
  description: `Analyze your mobile user data in SQL without building and maintaining an ETL pipeline. We’ll schematize and load your data for you.`,
}

const PipeDataWarehouse = () => {
  return (
    <SectionBase variant="2Col">
      <SectionCopy alignSelf="center">
        <CopyTextBase>
          <CopyText.Heading tag="h3">{copy.heading}</CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
        </CopyTextBase>
      </SectionCopy>
      <Section.Contents>
        <picture>
          <source
            type="image/webp"
            srcSet={`${PipeDataIntoWarehouseWebp}, ${PipeDataIntoWarehouseWebp2x} 2x, ${PipeDataIntoWarehouseWebp3x} 3x`}
          />
          <StyledImage
            src={PipeDataIntoWarehousePng2x}
            alt="Illustration: Activate anywhere"
            width="781"
            height="909"
            loading="lazy"
          />
        </picture>
      </Section.Contents>
    </SectionBase>
  )
}

const StyledImage = styled(Image)`
  filter: drop-shadow(${({ theme }) => theme.shadows[2]});
`

const SectionCopy = styled(Section.Copy)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 440px;
  }
`

export default PipeDataWarehouse
